import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toAbsoluteUrl } from "../../_helpers";
import axios from "axios";
// import { symbol } from "prop-types";
import { NODE_API_URL,BASE_URL, IVPCURRENCY } from "../../../env_config";
import { useHistory } from "react-router-dom";
import { SwalSuccess ,SwalError } from "./";
import Cookies from "js-cookie"
import PerfectScrollbar from "react-perfect-scrollbar";
import { Backdrop,CircularProgress,makeStyles} from "@material-ui/core";
import {OverlayTrigger,Tooltip} from "react-bootstrap";
import { FaInfoCircle,FaEdit} from "react-icons/fa";
import getSymbolFromCurrency from "currency-symbol-map";
import DiamondTypeTag from "./DiamondTypeTag";
import CertificateLink from "../CertificateLink";

const perfectScrollbarOptions = {
    wheelSpeed: 1,
    wheelPropagation: false,
};

const useStyles = makeStyles((theme) => ({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  }));

export const BuyDiamond = (props) => {
    const classes = useStyles();
    const [couponCode,setCouponCode] = useState("")
    const [displayCoupon,setDisplayCoupon] = useState(false)
    const [couponsuccessmsg,setCouponSuccessMsg] = useState("")
    const [couponerrormsg,setCouponErrorMsg] = useState("")
    const [showConfirm, setShowConfirm] = useState(false);
    const [swalSuccessOpen,setSwalSuccessOpen] = useState(false)
    const [swalErrorOpen,setSwalErrorOpen] = useState(false)
    const [alertMessage,setAlertMessage] = useState()
    const [refe,setRefe] = useState()
    const [inputValue, setInputValue] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [data , setData] =useState([])
    const [loading, setLoading] = React.useState(false);
    const [isSubmitting ,SetIsSubmitting] = useState(false)
    const [openLoader, setOpenLoader] = React.useState(false);
    const [totalourprice,setTotalOurPrice] = useState(0)
        const [totalourcarat,setTotalOurCarat] = useState(0)
        const [totalourpricecustomer,setTotalOurPriceCustomer] = useState(0)
        const [totalourratecustomer,setTotalOurRateCustomer] = useState(0)
        const [totalvalid,setTotalvalid] = useState(0)
        const [customerCurrencyRate, setCustomerCurrencyRate] = useState(1); 
        const [customerCurrencySymbol, setCustomerCurrencySymbol] = useState(null);
        const [customerCurrencySymbolName, setCustomerCurrencySymbolName] = useState(null);
        const [displayTotalUSD, setDisplayTotalUSD] = useState(false);

    const enableLoading = () => {
        setLoading(true);
        setOpenLoader(true);
        SetIsSubmitting(true)
    };
    const disableLoading = () => {
        setLoading(false);
        setOpenLoader(false);
        SetIsSubmitting(false)
    };

    const history = useHistory()
    useEffect(() => {
        let BASEURL = "https://api.staging.global.diamondsupload.com"
        if (process.env.REACT_APP_ENV === "production") {
            BASEURL = "https://api.global.diamondsoncall.com"
        }
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${BASEURL}/coupon/checkCouponRegionAvailable`,
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}`
            },
            data: {
                "region": "Global"
            }
        };
        axios.request(config)
            .then((response) => {
                if (response?.data?.couponavailable) {
                    setDisplayCoupon(true)
                }
            })
            .catch((error) => {
                if(error?.response?.data?.message === "UnAuthorized!"){
                    var cookies = document.cookie.split(";");
                  for (var i = 0; i < cookies.length; i++) {
                    if(cookies[i] && !cookies[i].includes("view")){
                      var equals = cookies[i].indexOf("=");
                      var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                    }
                  }
                  
                  window.location.replace(`${BASE_URL}/logout`);
                }
            });
    },[])
    useEffect(() => {
        setData(props.diamondselected || [])
        SetComment(null)
        setShowConfirm(props.show)
    },[props.show])
    const closeModel = () => {
        props.onHide()
        setShowConfirm(false)
        setCouponCode("")
        setCouponSuccessMsg("")
        setCouponErrorMsg("")
    }
    // const closeSwal = (props) => {
    //     // props.onHide()
    //     setShowConfirm(true)
    //     setSwalSuccessOpen(false)
    // }
    // const swalSuccessOpenfn = (props) => {
    //     closeModel()
    //     setSwalSuccessOpen(true)
    // }
    // const swalErrorOpenfn = (props) => {
    //     closeModel()
    //     setSwalErrorOpen(true)
    // }

    const ConfirmDiamonds = (diamonds) => {
        const userData = JSON.parse(localStorage.getItem("userData"))
        let dianondinfo = diamonds.map(value => {
            return {
                "diamond_type": value.diamondType,
                "certificate": value.certificate,
                "diamond_id":value.stockID,
                "client_ref":value.client_ref
            }
        })
        const finalData = {
            "operation":"buy",
            "diamond_info":dianondinfo,
            "customer_comment":comment,
            "couponcode":couponCode
        }
        enableLoading()
        let BASEURL = "https://api.staging.global.diamondsupload.com"
        if(process.env.REACT_APP_ENV === "production"){
            BASEURL = "https://api.global.diamondsoncall.com"
        }
        axios({
            method: "POST",
            url: `${BASEURL}/INTL/ConformDiamond`,
            headers: {
                "Content-Type": "application/json",
                 "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
            },
            data: finalData,
        }).then(res => {
            disableLoading()
            // window.location.reload(true)
            reDirectToConfirm()
        }).catch(err => {
            disableLoading()
            if(err?.response?.data?.message === "UnAuthorized!"){
                var cookies = document.cookie.split(";");
              for (var i = 0; i < cookies.length; i++) {
                if(cookies[i] && !cookies[i].includes("view")){
                  var equals = cookies[i].indexOf("=");
                  var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                  document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                }
              }
              
              window.location.replace(`${BASE_URL}/logout`);
            }
        })
    }

    const reDirectToConfirm = () => {
        history.push({
            pathname: `/confirmgoods`
        })
    }

    const handleInputChange = (event,buyDataIdData,index) => {
        const value = event.target.value;
        // console.log(value.length)
        setInputValue(value);
        // setRefe(value)
        if (value.length > 29) {
          setErrorMessage('String length should not exceed 30 characters.');
        } else {
          setErrorMessage('');
        }
        let buyDataId = [...buyDataIdData]
        buyDataId[index] = {...buyDataId[index],client_ref:event.target.value}
        // console.log(buyDataId,"buyDataId")
        setData(buyDataId)
        // console.log(buyDataId)
    };

    const AddReference = (buyDataIdData,index) => {
        let buyDataId = [...buyDataIdData]
        buyDataId[index] = {...buyDataId[index],addref:true}
        setData(buyDataId)
        // console.log(buyDataId,"buyDataId1212")
        
    }

    const [comment,SetComment] = useState("")
    // console.log(comment,"COMMENT")
    function numberWithCommas(x) {
        if(x){
        return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        }
    }
    const handleApplyCoupon = () => {
        enableLoading()
        let BASEURL = "https://api.staging.global.diamondsupload.com"
        if (process.env.REACT_APP_ENV === "production") {
            BASEURL = "https://api.global.diamondsoncall.com"
        }
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${BASEURL}/coupon/applyCoupon`,
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}`
            },
            data: {
                "coupon": couponCode,
                "certificates": data.map(value => value.certificate)
            }
        };
        axios.request(config)
            .then((response) => {
                disableLoading();
                if (response?.data?.success) {
                    setCouponErrorMsg("")
                    setCouponSuccessMsg(response?.data?.message);
                }
                else {
                    setCouponSuccessMsg("")
                    setCouponErrorMsg(response?.data?.message);
                }
            })
            .catch((error) => {
                disableLoading();
                if(error?.response?.data?.message === "UnAuthorized!"){
                    var cookies = document.cookie.split(";");
                  for (var i = 0; i < cookies.length; i++) {
                    if(cookies[i] && !cookies[i].includes("view")){
                      var equals = cookies[i].indexOf("=");
                      var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                    }
                  }
                  
                  window.location.replace(`${BASE_URL}/logout`);
                }
            });
    }
    useEffect(() => {
        if (data.length) {
            if (data?.[0]?.customerCurrencyRate && data?.[0]?.ourPriceCustomerSymbol) {
                setCustomerCurrencyRate(data?.[0]?.customerCurrencyRate)
                setCustomerCurrencySymbol(data?.[0]?.ourPriceCustomerSymbol)
                setCustomerCurrencySymbolName(data?.[0]?.ourPriceCustomerSymbolName)
            }
            if (data?.[0]?.displayTotalUsd) {
                setDisplayTotalUSD(data?.[0]?.displayTotalUsd)
            }
            let totalprice = 0
            let totalcarat = 0
            let totalvalid = 0
            let totalpricecustomer = 0
            for (let i = 0; i < data.length; i++) {
                totalvalid += 1
                totalprice += data[i].ourPrice
                totalcarat += data[i].carat
                if (data[i].ourPriceCustomer) {
                    totalpricecustomer += data[i].ourPriceCustomer
                }
            }
            setTotalOurPrice(totalprice)
            setTotalOurPriceCustomer(totalpricecustomer)
            setTotalOurRateCustomer(totalpricecustomer / totalcarat || 0)
            setTotalOurCarat(totalprice / totalcarat || 0)
            setTotalvalid(totalvalid)
        }
    }, [data])
    return (
        <div>
            <Modal
                show={showConfirm}
                onHide={props.onHide}
                backdrop="static"
                keyboard={false}
                size="xl"
            >
                <Modal.Header>
                    <Modal.Title>{props.language.CONFIRM_GOODS_POPUP_CONFIRM_DIAMOND}</Modal.Title>
                    <div className="d-flex">
                        {customerCurrencySymbolName ?
                            <div className=" font-weight-bold font-size-lg d-flex mr-4">
                            {customerCurrencySymbolName} Rate: <div className="ml-2">{customerCurrencySymbol}{customerCurrencyRate}</div >
                            </div>
                        : null}
                        <button type="button" className="close" onClick={() => closeModel(props)}><span aria-hidden="true">×</span><span className="sr-only">Close</span></button>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        
                        <div className="col-12 d-flex justify-content-between mb-3">
                            <span>{props.language.CONFIRM_GOODS_POPUP_TOTAL_DIAMONDS} : {props.diamondselected.length}</span>
                            <div>
                                {((props.diamondselected.length) - props.diamondcount ) == 0 ? "":
                                 <div className="d-flex font-weight-bold">
                                    <div className="text-success mr-2">{props.diamondcount} Diamonds are valid</div> 
                                    <div className="text-danger">{((props.diamondselected.length) - props.diamondcount )} Diamonds are not consider in total</div>
                                </div>}
                            </div>
                        </div>
                        <div className="col-12">
                            <div
                                options={perfectScrollbarOptions}
                                className="custom-scrollbar border-bottom "
                                style={{ maxHeight: "322px", position: "relative" }}
                            >
                                <table className="table border-bottom">
                                    <thead>
                                        <tr className="bg-gray-100 sticky-top">
                                            <th className="text-center py-3">{props.language.CONFIRM_GOODS_POPUP_DIAMOND_DETAILS}</th>
                                            <th className="text-center py-3">{props.language.CONFIRM_GOODS_POPUP_DIAMOND_LOCATION} <br/> {props.language.CONFIRM_GOODS_POPUP_DIAMOND_SHIPPING_DAYS}</th>
                                            <th align="center" className="text-right py-3">
                                                {props.language.CONFIRM_GOODS_POPUP_OURPRICEUSD} <br />
                                                USD/CT
                                            </th>
                                            {customerCurrencySymbolName ?
                                                <th align="center" className="text-right py-3">
                                                    Our Price ({customerCurrencySymbolName}) <br />
                                                    {customerCurrencySymbol}/CT
                                                </th> 
                                            : null}
                                            <th className="text-center  py-3 align-middle">
                                                Client <br />
                                                Reference
                                            </th>
                                            {/* <th align="center" className="text-right py-3">
                                            {props.language.CONFIRM_GOODS_POPUP_OURPRICEINR} <br />
                                                INR/CT
                                            </th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {data.map((value,index) => (
                                        <tr className={`position-relative `}  key={index}>
                                            <td>
                                                {/* {value.country !== "INDIA"?
                                                    <span className="CanNotHold"> Unfortunately, Diamond location outside India cant be ordered</span>
                                                :""} */}
                                                {/* {value.can_hold === 1 ? "":  <span style={{fontSize:"8px",color:"red"}}> DIAMOND NOT AVAILABLE FOR HOLD</span> } */}
                                                <div className={`row`}>
                                                    <div className="col-2 text-center p-0">
                                                        {value.image ? (
                                                            <img className="img-fluid mr-2" alt={value.shape} src={value.image} width="50px" onError={e => {
                                                                e.currentTarget.src = toAbsoluteUrl(
                                                                    `/media/shape/${value.shape.toLowerCase()}-no.png`
                                                                )
                                                            }}/>
                                                        ) : (
                                                            <img className="img-fluid mr-2" alt={value.shape} src={toAbsoluteUrl(`/media/shape/${value.shape.toLowerCase()}-no.png`)} onError={e => {
                                                                e.currentTarget.src = toAbsoluteUrl(
                                                                    `/media/shape/noimage.jpg`
                                                                )
                                                            }} width="50px" style={{ backgroundColor:"#f4f4f4", }} />
                                                        )}
                                                    </div>
                                                    <div className="col-10 pl-2 p-0">
                                                        <div className="mb-1">
                                                            <DiamondTypeTag diamondTypeTagColor={value.diamondTypeTagColor} diamondTypeTag={value.diamondTypeTag}/>
                                                            <CertificateLink Certificate_link={value.certificate_link} lab={value.lab} certificate={value.certificate} className={`mx-2 small`} />
                                                            <span className="small ml-2">
                                                                {value.diamondType === "N" ? "N" : "L"}-{value.stockID}
                                                            </span>
                                                        </div>

                                                        <span className="text-dark font-weight-bold d-block">
                                                            {value.shape}{" "}
                                                            {value.carat}{" "}
                                                            {value.color}{" "}
                                                            {value.clarity}{" "}
                                                            {value.cut}{" "}
                                                            {value.polish}{" "}
                                                            {value.symmetry}{" "}
                                                            {value.fluorescence}{" "}
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className={`text-center`}>
                                                {value.country} <br />
                                                {value.shippingDays} Days 
                                            </td> 
                                            <td className={`text-right  font-weight-bold `}>
                                               ${numberWithCommas(parseFloat(value["ourPrice"]))}
                                               {value.supplierName?<OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id="tooltip">
                                                           Supplier Price: ${value["db_sa_price"]}<br/>
                                                           Our Charges: ${(Math.round((value["ourPrice"] - value["db_sa_price"]) * 100)/100).toFixed(2)} 
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span className="ml-2 text-hover-primary cursor-pointer"><FaInfoCircle /></span>
                                                </OverlayTrigger>:""}<br/>
                                               <span className="text-muted small">USD/CT {numberWithCommas(parseFloat(value["ourRate"]))}</span >
                                            </td>
                                            {value.ourPriceCustomer ?
                                                    <td align="center" className="text-right font-weight-bold py-3">
                                                        {value.ourPriceCustomerSymbol}{numberWithCommas(value.ourPriceCustomer)} <br />
                                                        <span className="small text-muted">{value.ourPriceCustomerSymbol}/CT {numberWithCommas(value.ourRateCustomer)}</span>
                                                    </td> 
                                                : null}
                                            <td className={`text-right   align-middle`}>
                                                {value.addref  ? 
                                                    <input type="text" className="form-control" onChange={(e) => handleInputChange(e,data,index)} maxLength={30} placeholder="Please enter reference"/>
                                                :
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip id="tooltip">
                                                            Click to add Reference
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <button className="btn btn-icon btn-outline-primary btn-sm" onClick={()=> AddReference(data,index)}><FaEdit className="font-size-h5"/></button>
                                                    </OverlayTrigger>
                                                }
                                            </td>
                                            {/* <td className={`text-right  font-weight-bold ${value.country !== "INDIA" ? "CanNotHoldDiv" : "" }`}>
                                                ₹{numberWithCommas(parseFloat(value["OurPrice(INR)"]))}<br/>
                                                <span className="text-muted small"> ₹/CT {numberWithCommas(parseFloat(value["INR/CT"]))}</span>
                                            </td> */}
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className=" font-weight-bold mt-4 font-italic" >{props.diamondselected.length > 4 ? "Scroll for explore all diamonds":""}</div>
                            {errorMessage && <p className="mb-1 text-danger">{errorMessage}</p>}
                            <div className="row my-5">
                            <div className="col-md-6">
                             {displayCoupon?<div className="row">   
                            <div class="col-md-8 input-group">
                            <input
                                type="text"
                                className="form-control"
                                onChange={(e) => setCouponCode(e.target.value)}
                                maxLength={30}
                                placeholder="Enter coupon code"
                                value={couponCode}
                                />
                                <div class="input-group-append">
                                <button class="btn btn-primary" type="button" onClick={handleApplyCoupon}>Apply</button>
                            </div>
                            </div>
                            
                            <div className="col-12">
                                {couponsuccessmsg?<span className="text-success small">{couponsuccessmsg}</span>:""}
                            {couponerrormsg?<span className="text-danger small">{couponerrormsg}</span>:""}
                            </div>
                            </div>:""}
                            </div>

                            <div className="col-md-6">
                            <div className="row">
                            {displayTotalUSD && customerCurrencySymbolName?<>
                                <div className="col-12 font-size-h6 text-right">
                                    USD/CT Price : ${numberWithCommas(totalourcarat)}
                                </div>
                                <div className="col-12 font-size-h6 mt-2 text-right font-weight-bold">
                                    Total USD : ${numberWithCommas(totalourprice)}
                                </div>
                                <div className="col-12 font-size-h6 mt-2 text-right font-weight-bold">
                                    Total {customerCurrencySymbolName} : {customerCurrencySymbol}{numberWithCommas(totalourpricecustomer)}
                                </div>
                                </>:customerCurrencySymbolName?<>
                                    <div className="col-12 font-size-h6 mt-2 text-right font-weight-bold">
                                    {customerCurrencySymbolName}/CT Price: {customerCurrencySymbol}{numberWithCommas(totalourratecustomer)}
                                </div>
                                <div className="col-12 font-size-h6 mt-2 text-right font-weight-bold">
                                    Total {customerCurrencySymbolName} : {customerCurrencySymbol}{numberWithCommas(totalourpricecustomer)}
                                </div>
                                </>:<>
                                <div className="col-12 font-size-h6 text-right">
                                    USD/CT Price : ${numberWithCommas(totalourcarat)}
                                </div>
                                <div className="col-12 font-size-h6 mt-2 text-right font-weight-bold">
                                    Total USD : ${numberWithCommas(totalourprice)}
                                </div>
                                </>}
                            </div>
                            </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <Form.Group controlId="Notes">
                                        <Form.Label>
                                            {props.language.CONFIRM_GOODS_POPUP_NOTES}:
                                        </Form.Label>
                                        <Form.Control as="textarea" rows="3" onChange={(e) => SetComment(e.target.value)} maxLength={256} placeholder="Please enter your notes if any"/>
                                    </Form.Group>
                                    <span className="p-2">255 Characters Remaining</span>
                                </div>
                            </div>
                            {/* <pre>{JSON.stringify(props)}</pre> */}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                {props.conversionrate !== 1?<div>
                    All Prices are under USD
                    </div>:""}
                    <Button variant="secondary" className="mr-2 font-weight-bold" onClick={() => closeModel(props)}>
                        {props.language.CONFIRM_GOODS_POPUP_CLOSE}
                    </Button>
                    <Button className="px-8 font-weight-bold" disabled={isSubmitting} variant="primary" onClick={() => ConfirmDiamonds(data)}>
                        {props.language.CONFIRM_GOODS_POPUP_CONFIRM_ORDER}
                        {loading && <span className="ml-1 spinner spinner-white"></span>}
                        <Backdrop className={classes.backdrop} open={openLoader} >
                            <div className="px-5 py-3 bg-white rounded shadow-sm d-flex justify-content-center align-items-center"><CircularProgress size="30px" color="secondary" /> <span className="pl-2 font-weight-bold text-dark">Processing..</span></div>
                        </Backdrop>
                    </Button>
                </Modal.Footer>
            </Modal>
            <SwalSuccess show={swalSuccessOpen} message={alertMessage} onClose={() => setSwalSuccessOpen(false)} responseOnOk={reDirectToConfirm}/> 
            <SwalError show={swalErrorOpen} message={alertMessage} onClose={() => setSwalErrorOpen(false)} /> 
        </div>
    );
};
